import React, {cloneElement, ReactElement, ReactNode} from 'react';
import { Chip } from "@ui/forms/input-field/chip-field/chip";
import { ChipList } from "@ui/forms/input-field/chip-field/chip-list";
import { Trans } from "@ui/i18n/trans";
import clsx from "clsx";

interface MediaPageHeaderLayoutProps {
  className?: string;
  image: ReactElement<{size: string; className?: string}>;
  title: ReactNode;
  badges?: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  description2?: ReactNode;
  actionButtons?: ReactNode;
  centerItems?: boolean;
  footer?: ReactNode;
}
export function MediaPageHeaderLayout({
  className,
  image,
  badges,
  title,
  subtitle,
  description,
  description2,
  actionButtons,
  footer,
  centerItems = false,
}: MediaPageHeaderLayoutProps) {
  return (
    <header
      className={clsx(
        'flex flex-col md:flex-row gap-24 md:gap-34',
        centerItems && 'items-center',
        className
      )}
    >
      {cloneElement(image, {
        size: image.props.size || 'w-256 h-256',
        className: clsx(image.props.className, 'mx-auto flex-shrink-0'),
      })}
      <div className="flex-auto min-w-0">
        {badges}
        <h1 className="text-2xl md:text-4xl font-semibold mb-14 text-center md:text-start">
          {title}
        </h1>
        {subtitle && <div className="w-max mx-auto md:mx-0">{subtitle}</div>}
        {description ? (
          <div className="text-muted mt-18 md:mt-26 text-sm w-max mx-auto md:mx-0">
            {description}
          </div>
        ) : null}
        {description2 ? (
          <div className="text-muted mt-5 md:mt-10 text-sm w-max mx-auto md:mx-0">
            {description2}
          </div>
        ) : null}
        <div className="mt-10 md:mt-30">{actionButtons}</div>
        {footer ? <div className="mt-10">{footer}</div> : null}
      </div>
    </header>
  );
}

interface ActionButtonClassNameProps {
  isFirst?: boolean;
}
export function actionButtonClassName({
  isFirst,
}: ActionButtonClassNameProps = {}) {
  return clsx('min-h-40', isFirst ? 'min-w-128 mr-20' : 'mr-10 min-w-100');
}


interface MediaBadgesProps {
  isAvailable?: boolean;
  isEncoded?: boolean;
  isReleased?: boolean;
  isExclusivity?: boolean;
}
export function MediaBadges({isAvailable = true, isEncoded = true, isReleased = true, isExclusivity = true}: MediaBadgesProps) {
  return (
    <>
      {(!isAvailable || !isEncoded || !isReleased || isExclusivity) && (
        <ChipList
          size="xs"
          color="positive"
          radius="rounded-full"
          className="justify-center md:justify-start"
        >
          {!isAvailable ? (
            <Chip color='danger'>
              <span className={clsx('capitalize')}><Trans message="Unavailable" /></span>
            </Chip>
          ) : <></>}
          {!isEncoded ? (
            <Chip color="chip">
              <span className={clsx('capitalize')}><Trans message="Unencoded" /></span>
            </Chip>
          ) : <></>}
          {!isReleased ? (
            <Chip>
              <span className={clsx('capitalize')}><Trans message="Out Soon" /></span>
            </Chip>
          ) : <></>}
          {isExclusivity ? (
            <Chip color="primary">
              <span className={clsx('capitalize')}><Trans message="Exclusive" /></span>
            </Chip>
          ) : <></>}
        </ChipList>
      )}
    </>
  );
}
